import React from 'react';
import { connect } from 'react-redux';
import { header } from "constants/table";
import moment from 'moment';
import { Reception, DuLieuHeThong } from 'api';
import { ShowIf } from 'components/utils';
import { DropDownChonHuongXuLy } from 'components/tt-forms';
import { TextArea, DropDown } from 'components/tt-forms/common';
import {validatable} from 'components/utils';
import {ContainerFileDinhKem} from 'components/upload';
import { msg } from "constants/message";
import {ConfirmDialog} from 'modules/dialog';

class ThongTinTiepCongDan extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      lbl_textArea: 'Ý kiến xử lý',
      require : false,
      enableDropDown: true,
      enableHuongXuLy: false,
      huongXuLy: '',
      ghiChuXuLy: '',
      popupConfirmSaveLoaiDon: props.popupConfirmSaveLoaiDon,
      hasFileChange: false,
      // BO_SUNG_THONG_TIN
      dsTaiLieuBoSung: [],
      dsTaiLieuBoSungRemove: [],
      dataHuongXuLy: [],
      dsTepDinhKem: [],
      dsTepDinhKemInputTuChoi: [{
        taiLieuVanThuId: '',
        ten: 'Thông báo từ chối tiếp công dân',
        required: false,
        tenFile: '',
        duongDan: '',
        ngayQuyetDinh: '',
        soQuyetDinh: '',
        loaiTepDinhKem: 'QUYET_DINH',
        typeRequired: 'TU_CHOI'
      }],
      dsTepDinhKemInputTraDon: [{
        taiLieuVanThuId: '',
        ten: this.props.loaiDon === 'DON_KHIEU_NAI' ? 'Văn bản về việc hướng dẫn người khiếu nại' : 'Văn bản về việc hướng dẫn người tố cáo',
        required: true,
        tenFile: '',
        duongDan: '',
        ngayQuyetDinh: '',
        soQuyetDinh: '',
        loaiTepDinhKem: 'QUYET_DINH',
        typeRequired: 'TRA_DON_VA_HUONG_DAN'
      }],
      dsTepDinhKemRemove: [],
      fileTuChoi: [],
      fileHuongDan: [],
      loaiDonValue: '',
      tarGetValue: '',
      tarGetText: ''
    }
  }

  componentDidMount() {
    this.setState({
      enableHuongXuLy: false,
      enableDropDown: true
    });
  }
  createTaiLieuDinhKem(loaiDon) {
    if (this.state.huongXuLy === 'TU_CHOI') {
      if (this.state.dsTepDinhKemInputTuChoi.length > 0) {
      let getItem = [];
      if (this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length > 0) {
        getItem = this.props.soTiepCongDan.listTaiLieuVanThu.filter(item => item.typeRequired === 'TU_CHOI');
        this.setState({dsTepDinhKemInputTuChoi: getItem});
       } else {
         this.props.dispatch({
           type: 'CHANGE_STATE_LOAIDON',
           data: false
         });
         this.props.dispatch({
           type: 'CHANGE_STATE_HUONGXULY',
           data: false
         });
         this.setState({
           dsTepDinhKemInputTuChoi: [{
             taiLieuVanThuId: '',
             ten: 'Thông báo từ chối tiếp công dân',
             required: false,
             tenFile: '',
             duongDan: '',
             ngayQuyetDinh: '',
             soQuyetDinh: '',
             loaiTepDinhKem: 'QUYET_DINH',
             typeRequired: 'TU_CHOI'
           }]
         });
       }
     } else {
       this.setState({
         dsTepDinhKemInputTuChoi: [{
           taiLieuVanThuId: '',
           ten: 'Thông báo từ chối tiếp công dân',
           required: false,
           tenFile: '',
           duongDan: '',
           ngayQuyetDinh: '',
           soQuyetDinh: '',
           loaiTepDinhKem: 'QUYET_DINH',
           typeRequired: 'TU_CHOI'
         }]
       });
     }
   } else if (this.state.huongXuLy === 'TRA_DON_VA_HUONG_DAN' && (loaiDon === 'DON_KHIEU_NAI' || loaiDon === 'DON_TO_CAO')) {
      if (this.state.dsTepDinhKemInputTraDon.length > 0) {
        this.state.dsTepDinhKemInputTraDon[0].ten = loaiDon === 'DON_KHIEU_NAI' ? 'Văn bản về việc hướng dẫn người khiếu nại' : 'Văn bản về việc hướng dẫn người tố cáo';
      }
      if (this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length > 0) {
        let getItem = [];
        getItem = this.props.soTiepCongDan.listTaiLieuVanThu.filter(item => item.typeRequired === 'TRA_DON_VA_HUONG_DAN');
        this.setState({dsTepDinhKemInputTraDon: getItem});
      } else {
        this.props.dispatch({
          type: 'CHANGE_STATE_LOAIDON',
          data: false
        });
        this.props.dispatch({
          type: 'CHANGE_STATE_HUONGXULY',
          data: false
        });
        this.setState({
          dsTepDinhKemInputTraDon: [{
            taiLieuVanThuId: '',
            ten: loaiDon === 'DON_KHIEU_NAI' ? 'Văn bản về việc hướng dẫn người khiếu nại' : 'Văn bản về việc hướng dẫn người tố cáo',
            required: true,
            tenFile: '',
            duongDan: '',
            ngayQuyetDinh: '',
            soQuyetDinh: '',
            loaiTepDinhKem: 'QUYET_DINH',
            typeRequired: 'TRA_DON_VA_HUONG_DAN'
          }]
        });
      }
    }
  }

  handleChange(name, e) {
    if (name === 'huongXuLy') {
      this.state[name] = e.target.value;
      this.state.ghiChuXuLy = '';
      this.createTaiLieuDinhKem(this.props.loaiDon);
      this.setHuongXuLy(this.state.huongXuLy);
      this.props.onChange(this.state);
    } else {
      this.state[name] = e.target.value;
      this.setState({...this.state});
      this.props.onChange(this.state);
    }
  }

  setHuongXuLy(name) {
    switch(name) {
      case 'TRA_DON_VA_HUONG_DAN':
        this.state.lbl_textArea = 'Nội dung hướng dẫn';
        this.state.require = false;
      break;
      case 'TU_CHOI':
        this.state.lbl_textArea = 'Lý do từ chối tiếp công dân';
        this.state.require = true;
      break;
      case 'BO_SUNG_THONG_TIN':
        this.state.lbl_textArea = 'Nội dung bổ sung';
        this.state.require = true;
      break;
      case 'TIEP_NHAN_DON':
      case 'YEU_CAU_GAP_LANH_DAO':
        this.state.lbl_textArea = 'Ý kiến xử lý';
        this.state.require = false;
      break;
      default:
        this.state.lbl_textArea = 'Ghi chú';
        this.state.require = false;
      break;
    }
  }

  async componentWillReceiveProps(nextProps) {
    if (this.state.searching != nextProps.searching) {
      this.setState({
        searching: nextProps.searching
      });

      this.setState({
        doSearch: nextProps.searching
      })
    }
    if (this.props.loaiDon != nextProps.loaiDon) {

      if (this.props.popupConfirmSaveLoaiDon === true || this.props.popupConfirmSaveHuongXuLy === true) {
        await this.props.dispatch({
          type: 'CHANGE_STATE_LOAIDON',
          data: false
        });
        await this.props.dispatch({
          type: 'CHANGE_STATE_HUONGXULY',
          data: false
        });
        await this.props.dispatch({
          type: 'REMOVE_LOAIDON_EDIT_FORM',
          data: []
        });
        await this.props.soTiepCongDan.listTaiLieuVanThu.forEach((item) => {
          Reception.actions.deleteTepDinhKem.request({
            id: item.taiLieuVanThuId
          });
        });
      }
      await this.createTaiLieuDinhKem(nextProps.loaiDon);
    }
    if ( this.props.thongTinTiepCongDan != nextProps.thongTinTiepCongDan) {
      this.createTaiLieuDinhKem(nextProps.thongTinTiepCongDan);
    }

    if (nextProps.soTiepCongDan != this.props.soTiepCongDan) {
      let data = nextProps.soTiepCongDan;
      if (this.state.tarGetValue) {
        await this.setState({huongXuLy : this.state.tarGetValue});
      } else {
        await this.setState({huongXuLy : data.huongXuLy || ''});
      }
      await this.setState({ghiChuXuLy : data.noiDungTiepCongDan});
      if (data.taiLieuBangChungBoSungs && data.taiLieuBangChungBoSungs.length > 0) {
        data.taiLieuBangChungBoSungs.forEach((item, i) => {
          this.state.dsTaiLieuBoSung[i] = {
            ten: item.ten,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            tinhTrang: item.tinhTrangTaiLieu || '',
            taiLieuBangChungId: item.taiLieuBangChungId
          };
        });
      }
      if (data.soThuTuLuotTiep == 1 && data.donSTCD.thanhLapDon) {
        this.state.enableDropDown = false;
        this.state.enableHuongXuLy = false;
      }

      if ((data.soThuTuLuotTiep > 1 && data.donSTCD.thanhLapDon) || (this.props.type && this.props.type == 'them-luot')) {
        this.state.dataHuongXuLy = [{
          giaTri: 'BO_SUNG_THONG_TIN',
          ten: 'Bổ sung thông tin'
        }];
        this.state.ghiChuXuLy = '';
        this.state.huongXuLy = 'BO_SUNG_THONG_TIN';
        this.state.enableHuongXuLy = true;
        this.state.enableDropDown = false;
      }
      if (!data || (data.soThuTuLuotTiep == 1 && !data.donSTCD.thanhLapDon) || (data.soThuTuLuotTiep > 1 && !data.donSTCD.thanhLapDon)) {
        this.state.enableDropDown = true;
        this.state.enableHuongXuLy = false;
      }
      this.setHuongXuLy(this.state.huongXuLy);

      this.setState({...this.state});
      this.props.onInit(this.state);
    }
  }

  handleChangeDate(name, e) {
    let newData = {
      ...this.state
    }
    if (e && e._d) {
      newData[name] = e._d;
    } else {
      newData[name] = e;
    }
    this.setState({...newData});

    this.props.onChange(newData);
  }

  onFileRemove(id, data) {
    if (this.state.huongXuLy == 'BO_SUNG_THONG_TIN') {
      this.state.dsTaiLieuBoSungRemove = [
        ...this.state.dsTaiLieuBoSungRemove,
        id
      ];
      this.state.dsTaiLieuBoSung = data;
    } else {
      this.state.dsTepDinhKemRemove = [
        ...this.state.dsTepDinhKemRemove,
        id
      ];
      this.state.dsTepDinhKem = data;
    }
    this.setState({...this.state});
    this.props.onChange(this.state);
  }

  onFileChange(data) {
    if (this.state.huongXuLy == 'BO_SUNG_THONG_TIN') {
      this.state.dsTaiLieuBoSung = data;
    } else {
      this.state.dsTepDinhKem = data;
    }
    this.setState({...this.state});
    this.props.onChange(this.state);
  }
  confirmSaveLoaiDons(next) {
    if (next) {
      if (this.state.loaiDonValue === 'huongXuLy') {
        let oldState = this.state.loaiDonValue;
        this.state[oldState] = this.state.tarGetValue;
        this.state.ghiChuXuLy = '';
        this.setHuongXuLy(this.state.huongXuLy);
        this.props.dispatch({
          type: 'REMOVE_LOAIDON_EDIT_FORM',
          data: []
        });
        this.props.dispatch({
          type: 'CHANGE_STATE_HUONGXULY',
          data: false
        });
        this.props.soTiepCongDan.listTaiLieuVanThu.forEach((item) => {
          Reception.actions.deleteTepDinhKem.request({
            id: item.taiLieuVanThuId
          });
        });
      }
    } else {
      this.props.dispatch({
        type: 'CHANGE_STATE_HUONGXULY',
        data: false
      });
    }
  }

  onOpen(name, e) {
    if (this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length > 0) {
      this.props.dispatch({
        type: 'CHANGE_STATE_HUONGXULY',
        data: true
      });
    } else {
      this.props.dispatch({
        type: 'CHANGE_STATE_HUONGXULY',
        data: false
      });
    }
    this.setState({
      loaiDonValue: name,
      tarGetValue: e.target.value,
      tarGetText: e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text
    });
  }

  render() {
    return (
      <div className="box-items mb0-18">
        <div className="box-forward">
          <div className="container-box">
            <div className="group-box">
              <div className="title">
                <div className="rows">
                  <div className="col-12 mt15">
                    <h3>Thông tin xử lý lượt tiếp công dân</h3>
                  </div>
                </div>
              </div>
              <div className="items-form">
                <ShowIf condition={this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length > 0}>
                  <ConfirmDialog title={msg.confirmChangeSaveHXL} open={this.props.popupConfirmSaveHuongXuLy} onClose={this.confirmSaveLoaiDons.bind(this, false)} onSuccess={this.confirmSaveLoaiDons.bind(this, true)}/>
                  <ShowIf condition={this.state.enableDropDown}>
                    <div className="rows">
                      <DropDownChonHuongXuLy type={this.props.type} selected={this.state.huongXuLy} bindValidator={this} onChange={this.onOpen.bind(this, 'huongXuLy')} require={true} placeholder/>
                    </div>
                  </ShowIf>
                </ShowIf>
                <ShowIf condition={this.props.popupConfirmSaveHuongXuLy === false && this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length === 0}>
                  <ShowIf condition={this.state.enableDropDown}>
                    <div className="rows">
                      <DropDownChonHuongXuLy type={this.props.type} selected={this.state.huongXuLy} bindValidator={this} onChange={this.handleChange.bind(this, 'huongXuLy')} require={true} placeholder/>
                    </div>
                  </ShowIf>
                </ShowIf>
                <ShowIf condition={this.state.enableHuongXuLy}>
                  <div className="rows">
                    <DropDown label="Hướng xử lý" options={ this.state.dataHuongXuLy }
                      keyName='giaTri' valueName='ten'
                      onChange={ this.handleChange.bind(this, 'huongXuLy') }
                      placeholder={ null }
                      require
                      bindValidator={this}
                      channel="formTaoDon"
                      selectedValue={this.state.huongXuLy}
                      name="dropdownChonXuLy"/>
                  </div>
                </ShowIf>
                <div className="rows">
                  <TextArea label={this.state.lbl_textArea} className="col-12" bindValidator={this} channel="formTaoDon" rows={3} onChange={this.handleChange.bind(this, 'ghiChuXuLy')} maxLength={1000} value={this.state.ghiChuXuLy} require={this.state.require} name="textareaYKien"/>
                </div>
                <div className="rows">
                  <ShowIf condition={this.state.huongXuLy == 'BO_SUNG_THONG_TIN'}>
                    <div className="title">
                      <div className="rows pl5 pr5">
                        <h3 className="mb0-18">Tài liệu bổ sung</h3>
                      </div>
                    </div>
                    <div className="items-form container-filedinhkem">
                      <div className="rows">
                        <div className="col-12">
                          <ContainerFileDinhKem ref='containerFileDinhKem' label="Tài liệu bổ sung" type='TAI_LIEU_BO_SUNG' header = {header.addReception.danhSachBangChung} data={this.state.dsTaiLieuBoSung} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} onSave={this.props.onSave}/>
                        </div>
                      </div>
                    </div>
                  </ShowIf>
                  <ShowIf condition={this.state.huongXuLy === 'TU_CHOI'}>
                    <div className="items-form container-filedinhkem">
                      <div className="rows">
                        <div className="col-12">
                          <ContainerFileDinhKem ref='containerFileDinhKem' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.dsTepDinhKemInputTuChoi} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} name="fileDinhKemTuChoi" onSave={this.props.onSave}/>
                        </div>
                      </div>
                    </div>
                  </ShowIf>
                  <ShowIf condition={this.state.huongXuLy === 'TRA_DON_VA_HUONG_DAN' && (this.props.loaiDon === 'DON_KHIEU_NAI' || this.props.loaiDon === 'DON_TO_CAO')}>
                    <div className="items-form container-filedinhkem">
                      <div className="rows">
                        <div className="col-12">
                          <ContainerFileDinhKem ref='containerFileDinhKem' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.dsTepDinhKemInputTraDon} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} name="fileDinhKemTraDon" onSave={this.props.onSave}/>
                        </div>
                      </div>
                    </div>
                  </ShowIf>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*box-forward*/}
      </div>
    )
  }
}

ThongTinTiepCongDan.defaultProps = {
  soTiepCongDan: {},
  popupConfirmSaveLoaiDon: false,
  popupConfirmSaveHuongXuLy: false,
  type: '',
  onSave: false,
  loaiDon: ''
}

function bindStateToProps(state) {
  return {
    soTiepCongDan: state.formDataTiepCongDan.soTiepCongDan,
    popupConfirmSaveLoaiDon: state.formDataTiepCongDan.popupConfirmSaveLoaiDon,
    popupConfirmSaveHuongXuLy: state.formDataTiepCongDan.popupConfirmSaveHuongXuLy
  };
}

export default connect(bindStateToProps)(validatable(ThongTinTiepCongDan));



// WEBPACK FOOTER //
// ./src/components/modules/reception/ThongTinTiepCongDan.jsx